import { FormattedMessage } from 'react-intl';
import { calcDuration } from 'src/utils/helpers/calcDuration';
import { formatDateShort } from 'src/utils/helpers/transformDate';
import { withEmptyFallback } from './helpers/withEmptyFallback';
import { processItems } from './helpers/processItems';

const formatActiveObjectionDesc = (obj) => {
	const formattedDate = formatDateShort(obj.createdAt);
	const duration = calcDuration(obj, 'createdAt');

	return (
		<>
			{/* TODO: оставить или убрать comment? */}
			{obj.comment}
			<br />
			{formattedDate} (
			<FormattedMessage
				id="CellRender.duration.days"
				values={{ count: duration }}
				defaultMessage="{count, plural, =0 {менее дня} one {# день} few {# дня} many {# дней} other {# дней}}"
			/>
			)
		</>
	);
};

const formatDisabledObjectionDesc = (obj) => {
	const formattedDate = formatDateShort(obj.createdAt);
	const formattedSolvedDate = formatDateShort(
		obj.solvedAt || obj.deletedAt || null,
	);

	return (
		<>
			Создано {formattedDate} · Снято {formattedSolvedDate}
		</>
	);
};

export const companySideAreaObjections = (company) => {
	const emptyObjection = {
		id: 'empty-objections-list',
		label: 'Нет возражений',
	};
	const { activeItems, disabledItems } = processItems({
		array: company.objections,
		checkActive: (obj) => !obj.solved && !obj.isDeleted,
		transformArray: (obj, isActive) => ({
			id: obj.id,
			label: obj.type.name,
			desc: isActive
				? formatActiveObjectionDesc(obj)
				: formatDisabledObjectionDesc(obj),
		}),
		sortArray: (items) =>
			items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
	});

	if (!activeItems.length && !disabledItems.length) return null;

	return {
		id: 'objections',
		label: 'Возражения',
		items: [
			{
				id: 'objections-list',
				plate: {
					collapseLabel: `Снятые возражения (${disabledItems.length})`,
				},
				data: {
					objections: withEmptyFallback(activeItems, emptyObjection),
				},
				dataExtra: disabledItems.length
					? { objections: disabledItems }
					: null,
			},
		],
	};
};
